import { isArray, isEqual, isObject, transform } from "lodash";
import { get, set } from "lodash/object";

export const objectToArray = (obj, keyName) => {
  const arr = [];
  for (let item in obj) {
    if (obj.hasOwnProperty(item))
      arr.push({
        [keyName]: item,
        ...obj[item],
      });
  }
  return arr;
};

export const arrayToObject = (arr, keyName) => {
  const obj = {};
  arr.forEach((item) => {
    obj[item[keyName]] = {
      ...item,
    };
    delete obj[item[keyName]][keyName];
  });
  return obj;
};

export const propertyAsKeyObject = (obj, keyName) => {
  const cloned = { [obj[keyName]]: { ...obj } };
  delete cloned[keyName];
  return cloned;
};

export const difference = (
  origObj,
  newObj,
  objectsToBeReturnedCompletely = [],
  objectsWithDependencies = {}
) => {
  function changes(newObj, origObj, path = "") {
    return transform(newObj, function (result, value, key) {
      if (!origObj) {
        // If the original object is not present we want to include all the keys on the result
        result[key] = value;
        return;
      }
      if (!origObj.hasOwnProperty(key)) {
        // If the key is not present on the original object we want to include it on the result
        result[key] = value;
        return;
      }
      // For values that are equals we dont modify the result object
      // For the values that are not equals we need to return them on the result object
      if (!isEqual(value, origObj[key])) {
        if (isArray(origObj[key])) {
          // If it's an array we want to set the full array on the result since is what we need
          // to send to the API for update them, if not, we will end updating only the ones that
          // we've updated.
          result[key] = value;
        } else {
          // If it's an object and is not on the `objectsToBeReturnedCompletely` we want to check
          // which values are being updated on it so we call the `changes` function recursively
          // until we found a "value" that is not an object, on that case (modified value and not
          // an object) we set it to the result.
          result[key] =
            isObject(value) &&
            isObject(origObj[key]) &&
            !objectsToBeReturnedCompletely.includes(key)
              ? changes(value, origObj[key], [path, key].join("."))
              : value;
        }
      }
    });
  }

  let diff = changes(newObj, origObj);

  // After calculate the diffs we should bear in mind that some fields depends on others
  // so it's important to include the dependencies of modified fields in order to calculate
  // the correct update for the further update requests.
  for (const dependant in objectsWithDependencies) {
    if (get(diff, dependant)) {
      const dependencies = objectsWithDependencies[dependant];
      dependencies.forEach((dependency) => {
        const value = get(newObj, dependency);
        diff = set(diff, dependency, value);
      });
    }
  }

  return diff;
};
